import { FC, useMemo } from 'react';

import cx from 'classnames';

import styles from './ImageBackground.module.scss';
import { TextBlock } from '../../../common';
import { ESizes, TImageBackgroundTexts } from '../../../../types';

export const ImageBackground: FC<{
  accept?: Record<string, string[]>;
  isDragging: boolean;
  isLoading?: boolean;
  isMobile?: boolean;
  maxSize?: number;
  notice?: string;
  size?: 'm' | 's';
  texts: TImageBackgroundTexts;
}> = ({
  accept,
  isDragging,
  isLoading,
  isMobile,
  maxSize,
  size = 'm',
  texts,
}) => {
  const requirements = useMemo(() => {
    const req: string[] = [];

    if (accept) {
      const extensions = Object.values(accept).flat();
      const uniqueExtensions = Array.from(new Set(extensions));
      req.push(...uniqueExtensions.map((ext) => ext.toUpperCase()));
    }

    if (maxSize) {
      const sizeInMB = Math.round(maxSize / (1024 * 1024));
      req.push(`${sizeInMB} MB`);
    }

    return req.length > 0 ? req : ['.PNG', '.JPEG', '5 MB'];
  }, [accept, maxSize]);

  return (
    <div
      className={cx(
        styles.imageBg,
        isLoading && styles.loading,
        styles[size],
        isMobile && styles.mobile,
      )}
    >
      {!isLoading && (
        <>
          <div className={cx(styles.icon, styles[size])} />

          <TextBlock align="center" color="secondary" line="150" size="s">
            {isDragging
              ? texts.dropFileHere
              : isMobile || size === ESizes.s
                ? texts.mobileUploadFile
                : texts.uploadFile}
          </TextBlock>

          {size === ESizes.m && (
            <div className={styles.requirements}>
              {requirements.map((requirement, i) => (
                <div className={styles.requirements__item} key={i}>
                  <TextBlock
                    className={styles.requirements__text}
                    color="note"
                    size="xs"
                  >
                    {requirement}
                  </TextBlock>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};
